import { QueryClient } from "@/compat/reactQuery";

// Typed as `any` so the ported v3-style positional calls
// (client.invalidateQueries([key]), client.cancelQueries([key]), etc.)
// type-check against the underlying v5 QueryClient without rewriting call sites.
const client: any = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const reactQueryUtils = {
  client,
};

export default reactQueryUtils;
